function createWorkerPool(workerUrl, poolSize, parseResponse) {
  const workers = [];
  for (let i = 0; i < poolSize; i++) {
    const w = new Worker(workerUrl);
    workers.push({ worker: w, busy: false });
  }
  const taskQueue = [];

  function processQueue() {
    if (taskQueue.length === 0) return;
    const freeIndex = workers.findIndex((w) => !w.busy);
    if (freeIndex === -1) return; // no hay workers libres

    const { data, resolve, reject } = taskQueue.shift();
    const wobj = workers[freeIndex];
    wobj.busy = true;

    wobj.worker.onmessage = (event) => {
      try {
        parseResponse(event, resolve, reject);
      } catch (err) {
        reject(err);
      } finally {
        wobj.busy = false;
        processQueue();
      }
    };

    wobj.worker.onerror = (err) => {
      wobj.busy = false;
      reject(err.message);
      processQueue();
    };

    wobj.worker.postMessage(data);
  }

  function runTask(data) {
    return new Promise((resolve, reject) => {
      taskQueue.push({ data, resolve, reject });
      processQueue();
    });
  }

  function terminateAll() {
    for (const w of workers) {
      w.worker.terminate();
    }
  }

  return { runTask, terminateAll };
}

// Keep worker entrypoints together so the selection UI can be tested without browser workers.
export function createHashPool() {
  return createWorkerPool(new URL("../components/photos/hashWorker.js", import.meta.url), 2, (event, resolve, reject) => {
    if (event.data.error) reject(event.data.error);
    else if (event.data.hash) resolve(event.data.hash);
    else reject("Formato de respuesta inesperado en hashWorker");
  });
}

export function createCompressionPool() {
  return createWorkerPool(new URL("../components/photos/imageCompressorWorker.js", import.meta.url), 2, (event, resolve, reject) => {
    const { success, compressedFile, error } = event.data;
    if (success) resolve(compressedFile);
    else reject(error || "Error desconocido al comprimir");
  });
}
